import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../castle-kit';
import * as g from '../../castle-kit-grounds';

/**
 * ORCHARD (Фруктовый сад) — an OPEN-AIR fruit orchard, the castle's restful green pocket. Recomposed for
 * AIR: a single tidy row of oak/blossom fruit trees frames the grove against the back, two picnic benches sit
 * under the boughs, and the stone WELL anchors the centre as the quiet gather-eye. Most of the floor is left
 * OPEN — a sunlit grove should feel airy, so the trees hug the wall-line, the seats face the well, and only a
 * lamppost (warm glow at dusk), a flower bed (a stroke of colour) and one harvest barrel dress the edges.
 * The HERO is the well at room-centre; the blossom-led tree row is its storybook backdrop.
 *
 * Geometry: zone (2800,1700) 760×340 → centre (3180,1870). Doors kept clear at N@x3180, W@y1870, and two on
 * the S wall (catacombs @x3020, royal-tower @x3400). Seats: orchard-bench-1 @(3000,1870), -2 @(3360,1870).
 */
const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art } = ctx;

  // ── HERO: the stone WELL at room-centre — the orchard's gather-eye, framed by the bench pair. ──
  place(ctx, g.well(art), 3180, 1880);

  // ── BACKDROP: a single tidy fruit-tree row hugging the back, blossom + oak alternating for storybook
  //    variety, set off the N door mouth (x3180) so the doorway stays clear. ──
  place(ctx, g.tree(art, 'blossom'), 2900, 1770);
  place(ctx, g.tree(art, 'oak'), 3060, 1770);
  place(ctx, g.tree(art, 'oak'), 3300, 1770);
  place(ctx, g.tree(art, 'blossom'), 3460, 1770);

  // ── SEATS: the two picnic benches under the boughs, each AT its exact seat anchor, framing the well. ──
  place(ctx, g.gardenBench(art), 3000, 1870);
  place(ctx, g.gardenBench(art), 3360, 1870);

  // ── A flower bed for a single stroke of colour, against the NORTH wall off the door lane. ──
  place(ctx, g.flowerBed(art), 3180, 1730);

  // ── LIGHT BEAT: one lamppost on the WEST edge pools warm light over the near bench at dusk. ──
  place(ctx, g.lamppost(art), 2840, 1900);

  // ── A lone harvest barrel tucked at the EAST edge — lived-in, on-narrative, off every walking lane. ──
  place(ctx, kit.barrel(art), 3510, 1900);
};

export default decorate;
